// react
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useDispatch } from "react-redux";
// store
import { routes } from "../../store/routes";
import { paymentService } from "../../store/services/ServicePayment";
import { removeAllFromBasket, emptyBasketConfiguration } from "../../store/actions";
// components
import { Loader, Dimmer, Button, Icon } from "semantic-ui-react";

// component
const PaymentFinish = () => {
    // state
    const [currentURL] = useState(window.location.href);
    const [processing, setProcessing] = useState(true);
    const [isPaid, setIsPaid] = useState(false);
    const dispatch = useDispatch();

    useEffect(() => {
        async function checkPayment() {
            setProcessing(true);
            const uri_params = currentURL.split("?")[1];

            const result = await paymentService.validatePayment(uri_params);

            if (result.status === 200) {
                dispatch(removeAllFromBasket());
                dispatch(emptyBasketConfiguration());
                setIsPaid(true);
            } else {
                setIsPaid(false);
            }

            setProcessing(false);
        }

        checkPayment();
    }, [currentURL, dispatch]);

    // template
    return (
        <div className="payment-finish-container">
            <div className="payment-finish-card">
                {processing ? (
                    <div className="payment-finish-loading">
                        <Dimmer active inverted>
                            <div className="payment-finish-loader-content">
                                <Loader size="massive" inverted>
                                    Prebieha overenie platby
                                </Loader>
                                <h3 className="payment-finish-loading-text">Počkajte prosím...</h3>
                            </div>
                        </Dimmer>
                    </div>
                ) : (
                    <div className="payment-finish-content">
                        <div className="payment-finish-logo">
                            <img
                                src="/images/logos/logo_dark_version.png"
                                alt="ActivityPoint Logo"
                            />
                        </div>

                        {isPaid ? (
                            <>
                                <div className="payment-finish-icon payment-finish-success">
                                    <Icon name="check" size="large" />
                                </div>
                                <h2 className="payment-finish-title">Platba bola úspešne zaplatená!</h2>
                                <p className="payment-finish-description">
                                    Ďakujeme za vašu platbu. Vaša objednávka bola úspešne spracovaná.
                                </p>
                                <Button
                                    className="payment-finish-button"
                                    color="pink"
                                    as={Link}
                                    to={routes.MY_ORDERS}
                                    size="large"
                                >
                                    <Icon name="list" />
                                    Prejsť na moje objednávky
                                </Button>
                            </>
                        ) : (
                            <>
                                <div className="payment-finish-icon payment-finish-error">
                                    <Icon name="times" size="large" />
                                </div>
                                <h2 className="payment-finish-title">Platbu sa nepodarilo overiť!</h2>
                                <p className="payment-finish-description">
                                    Ospravedlňujeme sa, ale nastala chyba pri overovaní vašej platby.
                                    Skúste to prosím znovu alebo nás kontaktujte.
                                </p>
                                <Button
                                    className="payment-finish-button"
                                    color="pink"
                                    as={Link}
                                    to={routes.MY_ORDERS}
                                    size="large"
                                >
                                    <Icon name="list" />
                                    Prejsť na moje objednávky
                                </Button>
                            </>
                        )}
                    </div>
                )}
            </div>
        </div>
    );
};

export default PaymentFinish;
